// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgg_a bhg_wj bhg_a bhg_q bhg_k","AdSlotMail__mail--notLoaded":"bgg_b bhg_ey bhg_bj bhg_wy","show-ad-not-loaded":"bgg_c","AdSlotMail__cta":"bgg_e"};